// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {Translations} from "@translations";
import {ClientApplication} from "@models";
import {
	ClientApplicationTile,
	IPermissionOverrule,
	SimMenuApptileService,
	SimSystemExtendedService,
	SimUserExtendedService,
} from "@services";
import {environment} from "../../../../../../environments/environment";

export interface DialogData_ConfigureApplicationTileDialogInput extends MatDialogDataBaseInput {
	currentlyUsedApplications: ClientApplication[];
	permissionOverrule: IPermissionOverrule;
}

export interface DialogData_ConfigureApplicationTileDialogOutput extends MatDialogDataBaseOutput {
	//-42 is used to inform the calling component to remove the tile
	newClientApplication?: ClientApplication | -42;
}

@Component({
	selector: "sim-configure-application-tile-dialog",
	templateUrl: "./configure-application-tile-dialog.component.html",
	styleUrls: ["./configure-application-tile-dialog.component.scss"],
	standalone: false,
})
export class ConfigureApplicationTileDialogComponent extends BasicMaterialDialog<
	ConfigureApplicationTileDialogComponent,
	DialogData_ConfigureApplicationTileDialogInput,
	DialogData_ConfigureApplicationTileDialogOutput
> {
	baseHref = environment.baseHref;

	T = Translations;
	selectedApplication: ClientApplication = null;

	APPLICATIONS = this._simMenuApptileService.ApplicationTiles;

	constructor(
		_injector: Injector,
		private _simSystemService: SimSystemExtendedService,
		private _simMenuApptileService: SimMenuApptileService,
		private _userService: SimUserExtendedService,
	) {
		super(_injector);
	}

	okClicked() {
		this.close({
			action: "ok",
			newClientApplication: this.selectedApplication,
		});
	}

	alreadyUsed(applicationKey: ClientApplication): boolean {
		return this.data.currentlyUsedApplications.some((value) => value === applicationKey);
	}

	selectApplication(applicationKey: ClientApplication) {
		if (this.selectedApplication === applicationKey) {
			this.selectedApplication = null;
		} else {
			this.selectedApplication = applicationKey;
		}
	}

	hasCustomPrerequisites(application: ClientApplicationTile) {
		return application.hasAllPrerequisites(this._userService, this.data.permissionOverrule);
	}
}
